import React, { useState, useEffect } from 'react';
import { FaEye, FaEdit, FaTrash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import DeleteModal from '../../components/DeleteBlogModal';
import Loader from '../../components/Loader';
import { apiRequestHandler } from '../../apiConfig/service';
import { toast } from 'react-toastify';
import { url } from '../../apiConfig/ApiConfig';
import { formatDate } from '../../utils/formatedDate';
import DataTable from 'react-data-table-component';

const getJobs = async (endPoint, token) => {
  const res = await apiRequestHandler({ endPoint, headers: { Authorization: `Bearer ${token}` } });
  return res?.job || [];
};

const JobList = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [jobs, setJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [jobToDelete, setJobToDelete] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoading(true);
    getJobs('allJob', localStorage.getItem('token'))
      .then((res) => setJobs(res))
      .catch(() => toast.error('Failed to load jobs'))
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    const filtered = jobs.filter((j) => j?.jobTitle?.toLowerCase().includes(searchTerm.toLowerCase()));
    setFilteredJobs(filtered);
  }, [searchTerm, jobs]);

  const handleDelete = async (id) => {
    setIsLoading(true);
    try {
      const res = await apiRequestHandler({
        method: 'DELETE',
        endPoint: `${url}/job/delete/${id}`,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      if (res?.success) {
        toast.success(res.message);
        const updated = await getJobs('allJob', localStorage.getItem('token'));
        setJobs(updated);
      } else toast.error(res.message);
    } catch {
      toast.error('Something went wrong');
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      name: 'Sr No.',
      selector: (row, index) => (currentPage - 1) * 10 + index + 1,
      width: '80px',
    },
    {
      name: 'Job Title',
      selector: (row) => row.jobTitle,
      sortable: true,
    },
    {
      name: 'Experience',
      selector: (row) =>  `${row.minExp } - ${row.maxExp}`,
    },
    {
      name: 'Vacancies',
      selector: (row) => row.noOfVacancies,
    },
    {
      name: 'Created At',
      selector: (row) => row.createdAt,
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (row) => (
        <>
          <FaEye title="View" style={{ color: '#00bfa5', cursor: 'pointer', marginRight: 10 }} onClick={() => navigate('/admin/add-job', { state: { job: row, mode: 'view' } })} />
          <FaEdit title="Edit" style={{ color: '#ff9800', cursor: 'pointer', marginRight: 10 }} onClick={() => navigate('/admin/add-job', { state: { job: row, mode: 'edit' } })} />
          <FaTrash title="Delete" style={{ color: '#f44336', cursor: 'pointer' }} onClick={() => { setJobToDelete(row); setShowDeleteModal(true); }} />
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <div style={{ minHeight: '100vh', padding: '20px', background: '#f5f7fa' }}>
      <div style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '10px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
          <h4>Job Management</h4>
          <button
            onClick={() => navigate('/admin/add-job')}
            style={{  background: "linear-gradient(to bottom right, #163252, #0081ff)",
              color: "#fff",
              border: "none",
              padding: "8px 16px",
              borderRadius: "5px",
              cursor: "pointer",
              fontSize: "14px", }}
          >
            + Add Job
          </button>
        </div>
        </div>
        <div className="modifyTable" style={{ borderRadius: "10px", marginTop: "20px" }}>
          <DataTable
            columns={columns}
            data={filteredJobs}
            pagination
            highlightOnHover
            striped
            responsive
            progressPending={isLoading}
            onChangePage={setCurrentPage}
            paginationDefaultPage={currentPage}
            subHeader
            subHeaderComponent={
              <input
                type="text"
                placeholder="Search by job title..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px', width: '300px' }}
              />
            }
          />
        </div>

      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={() => {
          handleDelete(jobToDelete?._id);
          setShowDeleteModal(false);
          setJobToDelete(null);
        }}
      />
    </div>
  );
};

export default JobList;
